import Loading from './Loading';
import styles from './LoadingOverlay.module.less';

const LoadingOverlay = () => (
  <div className={styles.fullscreen}>
    <Loading />
  </div>
);

export default LoadingOverlay;
